import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { FaSearch } from "react-icons/fa";
import { toast } from "../../utils/appToast";

import Cookies from "js-cookie";
import CreateTagModal from "./CreateTagModal";
import api from "../chat/api";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import UploadModal from "../Contract/UploadModal";
import FilterTags from "./FilterTags";
import bell from "../../Images/ai-bell.png";
import search from "../../Images/search-big.jpg";
import axios from "axios";
import "../Contract/contract_data.css";
import Spinner from "../Contract/Spinner";
import CustomDropdown from "../Contract/CustomDropdown";
import EditTagModal from "./EditTagModal";
import TagOverflowTooltip from "./TagOverflowTooltip";
const ContractTable = ({isMenuOpen}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulkDelete, setIsBulkDelete] = useState(false);
  const [exportInProgress, setExportInProgress] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [token, setToken] = useState(null);
 const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(null);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [editContractId, setEditContractId] = useState(null);
  const [editedContractData, setEditedContractData] = useState({});
  const [loading, setLoading] = useState(false);
  const editRowRef = useRef(null);
  const [selectedinvoices, setSelectedinvoices] = useState([]);
  const [selectedContractKeys, setSelectedContractKeys] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [contractToDelete, setContractToDelete] = useState(null);
  const actionMenuRef = useRef(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [timeRange, setTimeRange] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
    const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [clickedAction, setClickedAction] = useState(null);
  const [invoice_name, setInvoiceName] = useState("");
const [actionMenuPosition, setActionMenuPosition] = useState({ top: 0, left: 0, openUpwards: false });
const [deleteInProgress, setDeleteInProgress] = useState(false);
const [renameSuccessRowId, setRenameSuccessRowId] = useState(null);
const[isCustomApplyFieldModal,setIsCustomApplyFiledModal] =useState(false);
const [customFieldsLoading, setCustomFieldsLoading] = useState(false);
const [isCustomFieldModalOpen, setIsCustomFieldModalOpen] = useState(false);
const [selectedTab, setSelectedTab] = useState("manage");
const [fieldName, setFieldName] = useState("");
const [fieldPrompt, setFieldPrompt] = useState("");
const [customFields, setCustomFields] = useState([]);
const [loadingAddField, setLoadingAddField] = useState(false);
const [deletingField, setDeletingField] = useState(null);
const isMaxFieldsReached = customFields.length >= 5;
const isFilled = fieldName.trim() && fieldPrompt.trim();
const [fieldCreationSuccess, setFieldCreationSuccess] = useState(false);
const moreButtonRef = useRef(null);
const [dropdownCoords, setDropdownCoords] = useState({ top: 0, left: 0 });
const [isCreatingNew, setIsCreatingNew] = useState(false);
const [selectedField, setSelectedField] = useState('');
const [newFieldName, setNewFieldName] = useState('');
const [newPrompt, setNewPrompt] = useState('');
const baseColumns = 7; // name, party A, party B, date, etc.
const totalColumns = baseColumns + customFields.length;
const uploadButtonRef = useRef(null);
const [selectedFilterTags, setSelectedFilterTags] = useState([]); // array of tag IDs
const [filterTagObjects, setFilterTagObjects] = useState([]); // array of full tag objects
const [tooltipCoords, setTooltipCoords] = useState({ top: 0, left: 0 });
const filterButtonRef = useRef(null);
const [showTooltip, setShowTooltip] = useState(false);
const tooltipRef = useRef(null);
const [customFieldPopup, setCustomFieldPopup] = useState({
  visible: false,
  value: '',
  contractKey: '',
  contractId: '',
  x: 0,
  y: 0,
});
const [showErrorPopup, setShowErrorPopup] = useState(false);
const [errorMessage, setErrorMessage] = useState("");

const [editTagModalOpen, setEditTagModalOpen] = useState(false);
const [selectedTagForEdit, setSelectedTagForEdit] = useState(null);
const popupRef = useRef(null);
const minWidthPercent = totalColumns * 15; // e.g., 9 * 15 = 135
const [isLoading, setIsLoading] = useState(false);
    const handleFileChange = (event) => {
const selectedFiles = Array.from(event.target.files || []);
if (selectedFiles.length === 0) return;

setFile(selectedFiles); // ✅ save to state
setIsModalOpen(true);
};
  const [filterApplied, setFilterApplied] = useState(false);
  const navigate = useNavigate();
  const handleFilterApply = (selectedNames) => {
  setSelectedFilterTags(selectedNames); // still names like ['kunalll', 'helloss']
  setIsFilterModalOpen(false);

  api.get("/api/tagging/tags/filter/", {
    params: { tags: selectedNames.join(",") },
  }).then(res => {
    setFilterTagObjects(res.data || []);
    setinvoices(res.data || []); // 👈 THIS UPDATES TABLE
  })
   .catch((err) => {
    handleApiError(err, "Failed to apply tag filters.");
  });
};

const handleApiError = (error, fallbackMessage = "Something went wrong. Please try again.") => {
  console.error("API Error:", error);
  const msg = error?.response?.data?.detail || error?.message || fallbackMessage;

  toast.error(msg, {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};



const handleFilterClear = () => {
  setSelectedFilterTags([]);
  setFilterTagObjects([]);
  setIsFilterModalOpen(false);
  setFilterApplied(false); // 👈 ensure default unfiltered state
  fetchinvoices(); // ⬅ reload entire table without any filters
};


const removeTagFromFilter = (id) => {
  const updated = selectedFilterTags.filter((tagId) => tagId !== id);
  setSelectedFilterTags(updated);
  setFilterTagObjects(filterTagObjects.filter(tag => tag.id !== id));
};
  const [filteredFiles, setFilteredFiles] = useState([]);

const [selectedFilters, setSelectedFilters] = useState({
  passport: false,
  id: false,
  visa: false,
  license: false,
});

const colorOptions = [
  "#D8FF75", "#7FFF7A", "#7AFFCE", "#7AEDFF", "#7ABEFF",
  "#7A9FFF", "#B27AFF", "#E97AFF", "#FF7AD7", "#FF7AA5",
  "#FF7A7A", "#FFFFFF", "#F7F7F7"
];

useEffect(() => {
const cookieToken = Cookies.get("access_token");
if (cookieToken) {
  setToken(cookieToken);
} else {
  console.error("Access token missing from cookies");
}
}, []);

  const toggleModal = () => {
   
    setIsModalOpen((prev) => !prev);
  };




const handleToggleMore = () => {
  if (isActionMenuOpen === "more") {
    setIsActionMenuOpen(null);
  } else {
    const rect = moreButtonRef.current.getBoundingClientRect();
    setDropdownCoords({
      top: rect.bottom + window.scrollY + 6,  // Add spacing
      left: rect.left + window.scrollX,       // Align horizontally
    });
    setIsActionMenuOpen("more");
  }
};


const [selectedColor, setSelectedColor] = useState("");
const openColorPicker = () => {
  alert("Color picker not implemented yet.");
};


const handleAddField = async () => {
  if (!fieldName.trim() || !selectedColor) return;
  try {
    setLoadingAddField(true);

    await api.post("/api/tagging/tags/", {
      name: fieldName.trim(),
      color: selectedColor,
      description: fieldPrompt.trim() || "", // optional
    });

    setFieldName("");
    setFieldPrompt("");
    setSelectedColor("");
    await fetchinvoices?.();     // optional

    setFieldCreationSuccess(true);
    setTimeout(() => setFieldCreationSuccess(false), 3000);
    setIsCustomFieldModalOpen(false);
} catch (error) {
  handleApiError(error, "Failed to create tag.");
  } finally {
    setLoadingAddField(false);
  }
};

const [tags, setTags] = useState([]);
const [tagSearchQuery, setTagSearchQuery] = useState("");

  function darkenColor(hex, amount = 0.4) {
  if (!hex || !hex.startsWith('#')) return '#333';
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  // darken each channel
  r = Math.floor(r * (1 - amount));
  g = Math.floor(g * (1 - amount));
  b = Math.floor(b * (1 - amount));

  return `rgb(${r}, ${g}, ${b})`;
}
  const fetchinvoices = useCallback(async () => {
   if (!token) return;
  setLoading(true);

  try {
    let url = `/api/tagging/tags/`;
    let params = {};

    // Optional: include a search filter if you have `tagSearchQuery`
    if (isFilterApplied && tagSearchQuery) {
      params = { search: tagSearchQuery };
    }

    const response = await api.get(url, { params });
const sortedTags = [...(response.data || [])].sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
);
setinvoices(sortedTags);

} catch (error) {
  handleApiError(error, "Failed to fetch tags.");
  } finally {
    setLoading(false);
  }
}, [token, isFilterApplied, tagSearchQuery]);
  
  

  const tableBodyRef = useRef(null);

  const scrollToTop = () => {
    if (tableBodyRef.current) {
      tableBodyRef.current.scrollTop = 0;
    }
  };

  const handleSelectAll = () => {
    if (selectedinvoices.length === invoices.length) {
      setSelectedinvoices([]);
      setSelectedContractKeys([]);
    } else {
      setSelectedinvoices(invoices.map((contract) => contract.id));
      setSelectedContractKeys(invoices.map((contract) => contract.key));
    }
  };

const filteredinvoices = useMemo(() => {
  const query = searchQuery?.toLowerCase() || "";
  return (invoices || []).filter((invoice) => {
    const invoiceName = invoice?.name?.toLowerCase() || ""; 
    const customerName = invoice?.details?.["Customer name"]?.toLowerCase() || "";
    const vendorName = invoice?.details?.["Vendor name"]?.toLowerCase() || "";

    return (
      invoiceName.includes(query) ||
      customerName.includes(query) ||
      vendorName.includes(query)
    );
  });
}, [invoices, searchQuery]);



  const indexOfLastContract = currentPage * rowsPerPage;
  const indexOfFirstContract = indexOfLastContract - rowsPerPage;
  const currentinvoices = useMemo(() => {
    const indexOfLastContract = currentPage * rowsPerPage;
    const indexOfFirstContract = indexOfLastContract - rowsPerPage;
    return filteredinvoices.slice(indexOfFirstContract, indexOfLastContract);
  }, [filteredinvoices, currentPage, rowsPerPage]);

  const totalPages = useMemo(
    () => Math.ceil(filteredinvoices.length / rowsPerPage),
    [filteredinvoices, rowsPerPage]
  );
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleCheckboxChange = (id, key) => {
    if (selectedinvoices.includes(id)) {
      setSelectedinvoices(
        selectedinvoices.filter((contractId) => contractId !== id)
      );
      setSelectedContractKeys(
        selectedContractKeys.filter((contractKey) => contractKey !== key)
      );
    } else {
      setSelectedinvoices([...selectedinvoices, id]);
      setSelectedContractKeys([...selectedContractKeys, key]);
    }
  };



  const tbodyRef = useRef(null);


  useEffect(() => {
    if (token) {
      fetchinvoices();
    }
  }, [fetchinvoices, token, isFilterApplied, filterType, timeRange, fromDate, toDate]);

  useEffect(() => {
    if (isFilterApplied) {
      localStorage.setItem("invoiceFilter", JSON.stringify({ filterType, timeRange, fromDate, toDate }));
    }
  }, [isFilterApplied, filterType, timeRange, fromDate, toDate]);

  
  // useEffect(() => {
  //   const storedFilters = JSON.parse(localStorage.getItem("invoiceFilter"));
  //   if (storedFilters) {
  //     setFilterType(storedFilters.filterType);
  //     setTimeRange(storedFilters.timeRange);
  //     setFromDate(storedFilters.fromDate);
  //     setToDate(storedFilters.toDate);
  //     setIsFilterApplied(true);
  //   }
  // }, []);
  

  const handleUploadSuccess = () => {
    fetchinvoices();
    toggleModal();
  };

  const handleCloseModal = () => {
    toggleModal();
    fetchinvoices();
  };

  const handlePageChange = (event) => {
    const newPage = Number(event.target.value);
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

 const toggleActionMenu = (index, event) => {
const menuHeight = 150; // Approximate height of the action menu
const rect = event.currentTarget.getBoundingClientRect();
const bottomSpace = window.innerHeight - rect.bottom;

const openUpwards = bottomSpace < menuHeight;

setIsActionMenuOpen(isActionMenuOpen === index ? null : index);
setActionMenuPosition({
top: openUpwards ? rect.top - menuHeight : rect.bottom,
left: rect.left,
openUpwards,
});
};

const toggleFilterModal = () => {
  setIsFilterModalOpen((prev) => !prev);
};

const handleViewMore = (invoiceKey) => {
  navigate(`/Invoices/Invoice_Details/${invoiceKey}`);
};


  const enableEdit = (invoice) => {
    if (invoice) {
      setIsActionMenuOpen(null);
      setEditContractId(invoice.id);

      
const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  // Handle DD-MM-YY or MM-DD-YY manually if needed
  const regex = /^(\d{1,2})[-/](\d{1,2})[-/](\d{2}|\d{4})$/;
  const match = dateString.match(regex);

  if (match) {
    let [_, part1, part2, part3] = match;

    // Ensure 4-digit year
    if (part3.length === 2) {
      part3 = parseInt(part3) < 50 ? "20" + part3 : "19" + part3;
    }

    // Try interpreting both ways
    const d1 = new Date(`${part3}-${part1}-${part2}`); // yyyy-mm-dd
    const d2 = new Date(`${part3}-${part2}-${part1}`); // yyyy-dd-mm

    // Pick the valid one
    if (!isNaN(d1.getTime()) && d1.getDate() == part2) {
      return d1.toISOString().split("T")[0];
    }
    if (!isNaN(d2.getTime()) && d2.getDate() == part1) {
      return d2.toISOString().split("T")[0];
    }
  }

  // Try Date object fallback
  const parsed = new Date(dateString);
  if (!isNaN(parsed.getTime())) {
    return parsed.toISOString().split("T")[0];
  }

  return ""; // fallback if all fails
};







      
      const extractAmountAndCurrency = (amount) => {
        if (!amount) return { value: "", currency: "" };

        const match = amount.toString().match(/^([\D]*)([\d,\.]+)$/); 
        if (match) {
          return {
            currency: match[1].trim(), 
            value: match[2].trim().replace(",", "."), 
          };
        }
        return { value: amount, currency: "" }; 
      };

      const { value, currency } = extractAmountAndCurrency(
        invoice.details?.["Total due amount"]
      );

      setEditedContractData({
        ...invoice,
        details: {
          ...invoice.details,
         "DOB": formatDateForInput(invoice.details?.["DOB"]),
    "Date of issue": formatDateForInput(invoice.details?.["Date of issue"]),
    "Date of expiry": formatDateForInput(invoice.details?.["Date of expiry"]),
    "Issued on": formatDateForInput(invoice.details?.["Issued on"]),
    "Due date": formatDateForInput(invoice.details?.["Due date"]),
    "Total due amount": value,
    Currency: currency,
        },
      });
      setInvoiceName(invoice.name || "");
    } else {
      setEditContractId(null);
      setEditedContractData({});
      setInvoiceName("");
    }
  };


const handleEditChange = (fieldPath, value) => {
  if (fieldPath.startsWith("details._custom_fields.")) {
    const key = fieldPath.split(".")[2];
    setEditedContractData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        _custom_fields: {
          ...(prev.details?._custom_fields || {}),
          [key]: value,
        },
      },
    }));
  } else if (fieldPath.startsWith("details.")) {
    const key = fieldPath.split(".")[1];
    setEditedContractData((prev) => ({
      ...prev,
      details: {
        ...prev.details,
        [key]: value,
      },
    }));
  } else {
    setEditedContractData((prev) => ({
      ...prev,
      [fieldPath]: value,
    }));
  }
};


  const handleClickOutside = (event) => {
    if (
      actionMenuRef.current &&
      !actionMenuRef.current.contains(event.target)
    ) {
      setIsActionMenuOpen(null);
    }
    if (
      confirmDeleteVisible &&
      event.target.closest(".popup-overlay") === null &&
      !event.target.closest(".popup-box-delete")
    ) {
      setConfirmDeleteVisible(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [confirmDeleteVisible, isActionMenuOpen]);

  const showPopup = (title, message) => {
    setPopupTitle(title);
    setPopupMessage(message);
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
  };
  const handleDelete = (contractId) => {
    
    setIsActionMenuOpen(null);
    setIsBulkDelete(false);
    setContractToDelete(contractId);
    setConfirmDeleteVisible(true);
  };

  const handleBulkDelete = () => {
   

    if (!selectedinvoices || selectedinvoices.length === 0) {
      showPopup("Error", "Please select at least one contract to delete.");
      return;
    }
    setIsActionMenuOpen(null);
    setIsBulkDelete(true);
    setConfirmDeleteVisible(true);
  };




const confirmDelete = async () => {
  const idsToDelete = isBulkDelete ? selectedinvoices : [contractToDelete];
  setDeleteInProgress(true);

  try {
    const deletedIds = [];

    for (const id of idsToDelete) {
      try {
        await api.delete(`/api/tagging/tags/${id}/`);
        deletedIds.push(id);
      } catch (innerErr) {
        console.error(`Failed to delete tag ${id}`, innerErr);
        showPopup("Error", `Failed to delete tag with ID ${id}`);
      }
    }

    if (deletedIds.length > 0) {
      setinvoices((prev) =>
        prev.filter((invoice) => !deletedIds.includes(invoice.id))
      );
      if (isBulkDelete) {
        setSelectedinvoices([]);
        setSelectedContractKeys([]);
      }
    }
  } catch (error) {
    console.error("Error during bulk deletion:", error);
    showPopup("Error", "An error occurred while deleting tags.");
  } finally {
    setDeleteInProgress(false);
    setConfirmDeleteVisible(false);
    setIsBulkDelete(false);
    setContractToDelete(null);
    fetchinvoices();
  }
};


  useEffect(() => {
    if (editContractId) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editContractId]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <>
      {loading && <Spinner />}
      <div className="full-container max-w-full overflow-x-hidden">
        <div className="">
          <Header name="Tags" icon={""} isMenuOpen={isMenuOpen} />
        </div>

     <div className="contract-table-container relative overflow-x-hidden">
     <div className="flex justify-between items-center contract-table-header overflow-x-hidden w-full pr-9 mt-[6px]">
  {/* LEFT: Search & Filter */}
  <div className="flex items-center gap-1 min-w-[300px]" style={{ marginLeft: isMenuOpen ? "206px" : "110px" }}>
    {/* Search */}
    <div
  style={{
    display: 'flex',
    width: '310px',
    height: '40px',
    padding: '8px 20px 8px 26px', // ← increased left padding
    alignItems: 'center',
    gap: '1px',
    flexShrink: 0,
    borderRadius: '20px',
    border: isSearchFocused
      ? '1px solid rgba(187, 66, 174, 0.36)'
      : '1px solid rgba(0, 0, 0, 0.10)',
    backgroundColor: '#FFF',
    boxShadow: isSearchFocused
      ? '0px 11px 3px rgba(0, 0, 0, 0.00), 0px 7px 3px rgba(0, 0, 0, 0.01), 0px 4px 2px rgba(0, 0, 0, 0.05), 0px 2px 2px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.10)'
      : 'none',
    overflow: 'hidden',
  }}
>
  <img
    src="/search.svg"
    alt="Search"
    style={{
      width: '24px',
      height: '24px',
      flexShrink: 0,
      marginRight: '4px', // ← extra spacing between icon and input
    }}
  />
  <input
    type="text"
    placeholder="Search Tags Here"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    onFocus={() => setIsSearchFocused(true)}
    onBlur={() => setIsSearchFocused(false)}
    style={{
      fontFamily: 'Outfit, sans-serif',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      border: 'none',
      outline: 'none',
      width: '100%',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
      color: '#171717',
    }}
  />
</div>

<div className="relative inline-flex items-center gap-2 flex-wrap ">
  {/* Filter Button */}
  <button
    ref={filterButtonRef}
    className={`${selectedFilterTags.length ? "filter-applieds" : ""}`}
    onClick={toggleFilterModal}
  >
    <img
      src={selectedFilterTags.length ? "/Filter_CTA.png" : "/filter.svg"}
      alt="Filter Icon"
    />
  </button>

  {/* 🔽 Background Blur Overlay */}
  {isFilterModalOpen && (
    <div className="fixed inset-0 z-[998] bg-black/5 backdrop-blur-[1.5px]" />
  )}

  {/* 🔽 Filter Dropdown */}
  {isFilterModalOpen && (
    <FilterTags
      selectedTags={filterTagObjects}
      onApply={handleFilterApply}
      onClear={handleFilterClear}
      onClose={() => setIsFilterModalOpen(false)}
      anchorRef={filterButtonRef}
    />
  )}

  {/* Selected tags */}
  {filterTagObjects.slice(0, 2).map((tag) => (
    <div
      key={tag.id}
      className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] whitespace-nowrap"
      style={{
        backgroundColor: `${tag.color}1A`,
        border: `2px solid ${tag.color}`,
        color: darkenColor(tag.color),
      }}
    >
      {tag.name}
    </div>
  ))}

  {/* "+N" More tags with tooltip */}
  {filterTagObjects.length > 2 && (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      ref={tooltipRef}
    >
      <div
        className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] cursor-default"
        style={{
          backgroundColor: "#F4EBFF",
          border: "1px solid #8B55DD",
          color: "#8B55DD",
        }}
      >
        +{filterTagObjects.length - 2}
      </div>

      {showTooltip && (
        <TagOverflowTooltip
          tags={filterTagObjects.slice(2)}
          anchorRef={tooltipRef}
        />
      )}
    </div>
  )}
</div>




  </div>

  {/* RIGHT: Custom field, Upload, Bulk Actions */}
  <div className="flex items-center gap-3 flex-wrap justify-end">
    {selectedinvoices.length > 0 ? (
      <>
       
      </>
    ) : (
      <>
        <button
          className="flex items-center gap-2 px-4 py-2 bg-white new-custom-butons-design mr-4"
          onClick={() => setIsCustomFieldModalOpen(true)}
        >
          <img src="/custom-field-icons.svg" className="w-5 h-5" />
          <span className="new-custom-butons-design-text">Create Tag</span>
        </button>

   

      </>
    )}
  </div>
</div>

         <div
        className={`overflow-x-auto  transition-all duration-300 mt-1 w-full`}
        style={{
          marginLeft: isMenuOpen ? "182px" : "80px"
        }}
      >
    <div className="overflow-x-auto w-[100%]">
      
      <div className="relative overflow-x-auto  custom-scrollbar-container"  style={{
      height: "calc(100vh - 158px)", // Adjust height as needed
    }}
    ref={tbodyRef}>
<table
  className="text-sm text-left table-auto w-full"
 
>
             <thead className="bg-[#FFF] h-[46px] text-[#1E1E1E] font-medium border-b border-[rgba(0,0,0,0.10)]">
  <tr>
    <th className="min-w-[130px] px-1 file-size-of-heading pl-12">
      <div className="flex items-center gap-2">
        <img src="/tag-icon.svg" alt="Tag Icon" className="w-4 h-4" />
        Name
      </div>
    </th>
    <th className="min-w-[130px] px-3 file-size-of-heading">Description</th>
    <th className="min-w-[100px] px-3 file-size-of-heading">Documents</th>
    <th className="min-w-[100px] px-3 file-size-of-heading">Created On</th>
    <th className="min-w-[150px] px-3 file-size-of-heading">Actions</th>
  </tr>
</thead>
           <tbody
  className={currentinvoices.length > rowsPerPage ? "scrollable" : ""}
  style={{
    overflowY: currentinvoices.length > rowsPerPage ? "auto" : "hidden",
    maxHeight: "400px",
    backgroundColor: "#FFF",
  }}
>
  {loading ? (
    <tr>
      <td colSpan="5" style={{ textAlign: "center" }}>
        <Spinner />
      </td>
    </tr>
  ) : invoices.length > 0 ? (
    currentinvoices.map((tag, index) => (
      <tr
        key={index}
        style={{
          background: hoveredRow === index ? "#F8F3FF" : "transparent",
          boxShadow:
            hoveredRow === index ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25)" : "none",
        }}
        onMouseEnter={() => setHoveredRow(index)}
        onMouseLeave={() => setHoveredRow(null)}
        className="h-[36px] border-b border-[rgba(0,0,0,0.10)] hover:bg-gray-50 transition"
      >
        {editContractId === tag.id ? (
          <>
            
          
           
            
          </>
        ) : (
          <>
          <td className="min-w-[130px] pl-12">
  <span
    className="inline-flex px-3 py-1 items-center justify-center gap-1 rounded-full text-[14px] font-medium"
    style={{
      backgroundColor: `${tag.color}1A`, // ~10% opacity
      border: `2px solid ${tag.color}`,
      color: darkenColor(tag.color),
      fontFamily: "Outfit",
    }}
  >
    {tag.name || "N/A"}
  </span>
</td>


            
            <td className=" px-3 file-size-of-subheading">
              {tag.description || "—"}
            </td>
   <td className="px-3">
  <div className="flex flex-col items-start gap-1">
    <div className="flex items-center">
      <img
        src="/file-tag.svg"
        alt="Document Icon"
        style={{ width: "20px", height: "20px" }}
      />
      <span
        style={{
          fontFamily: "Outfit",
          fontSize: "14px",
          fontWeight: 500,
          color: "#3F3F46",
          lineHeight: "normal",
        }}
      >
        {tag.document_count ?? 0}
      </span>
    </div>
    <div
      className="self-start"
      style={{
        width: "28px",
        height: "1px",
        backgroundColor: "rgba(82, 82, 91, 0.32)",
      }}
    ></div>
  </div>
</td>


            <td className="px-3 text-gray-500 text-sm">
              {new Date(tag.created_at).toLocaleDateString("en-GB")}
            </td>
            <td className="px-3">
              <img
                src="./action.svg"
                alt="Actions"
                width="20"
                height="20"
                onClick={(e) => toggleActionMenu(index, e)}
                style={{ cursor: "pointer" }}
              />
              {isActionMenuOpen === index && (
                <div
                  className="action-menus"
                  style={{
                    position: 'fixed',
                    top: `${actionMenuPosition.top}px`,
                    left: `${actionMenuPosition.left - 45}px`,
                    zIndex: 9999,
                  }}
                  ref={actionMenuRef}
                >
          <div
  onClick={() => {
  setSelectedTagForEdit({
    id: tag.id,
    name: tag.name,
    color: tag.color,
    description: tag.description,
  });
  setEditTagModalOpen(true);
}}
  className="flex items-center mt-2 ml-1 mr-1 gap-2 px-[10px] py-[6px] pr-[46px] rounded-md text-[14px] font-medium font-[Outfit] text-[#8B55DD] hover:bg-[rgba(139,85,221,0.16)] cursor-pointer"
>
  <img src="./edit.svg" className="w-4 h-4" alt="Edit" />
  Edit Tag
</div>


                 <div
  onClick={() => handleDelete(tag.id)}
  className="flex items-center mt-2 mr-1 ml-1 gap-2 px-[10px] py-[6px] pr-[46px] rounded-md text-[14px] font-medium font-[Outfit] text-red-500 hover:bg-red-100 cursor-pointer"
>
  <img src="./delete.svg" className="w-4 h-4" alt="Delete" />
  Delete
</div>

                </div>
              )}
            </td>
          </>
        )}
      </tr>
    ))
  ) : (
    <tr className="h-[44px] text-center">
      <td colSpan="5" className="py-6 text-black-400">
        <img
          src="/no-contracts.svg"
          alt="No Data"
          className="mx-auto mb-2"
        />
        <p className="text-[16px]">Looks like your table is empty!</p>
      </td>
    </tr>
  )}
</tbody>

            </table>
            </div>
            {invoices.length > 0 && (
              <div className="pagination-doc ml-2">
                 <div className="pagination-dropdown">
<p className="page-selector">{currentPage}</p>
</div>
                <p className="contentDown">of {totalPages} pages</p>
                <button
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  style={{
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="decrease.svg"
                    alt="Previous Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                  }}
                >
                  <img
                    src="increase.svg"
                    alt="Next Page"
                    style={{ height: "12px", width: "12px" }}
                  />
                </button>
              </div>
            )}
          </div>
        </div>
        </div>

        {popupVisible && (
                    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
            <div className="popup-box">
              <h2>{popupTitle}</h2>
              <p>{popupMessage}</p>
              <button onClick={closePopup} className="popup-close-button">
                Close
              </button>
            </div>
          </div>
        )}

            {confirmDeleteVisible && (
<div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
<div className="popup-box-delete">
  <h2>Are you sure you want to delete this tag?</h2>
  <p>
    {isBulkDelete
      ? "This tag will be removed from all documents it's applied to.You can’t undo this action."
      :  "This tag will be removed from all documents it's applied to.You can’t undo this action"}
  </p>
  <div
    style={{
      display: "flex",
      gap: "8px",
      justifyContent: "center",
      marginTop: "20px",
    }}
  >
   
    <button
      onClick={() => setConfirmDeleteVisible(false)}
      disabled={deleteInProgress}
      className="document-popup-close-delete"
    >
      Cancel
    </button>
     <button
      onClick={confirmDelete}
      disabled={deleteInProgress}
      className="document-popup-close-button"
    >
      {deleteInProgress ? "Deleting..." : "Delete"}
    </button>
  </div>
</div>
</div>
)}
        <UploadModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onUploadSuccess={handleUploadSuccess}
          type={"ocr"}
          file={file}
        />






<CreateTagModal
  isOpen={isCustomFieldModalOpen}
  onClose={() => setIsCustomFieldModalOpen(false)}
  fieldName={fieldName}
  setFieldName={setFieldName}
  selectedColor={selectedColor}
  setSelectedColor={setSelectedColor}
  fieldPrompt={fieldPrompt}
  setFieldPrompt={setFieldPrompt}
  colorOptions={colorOptions}
  handleAddField={handleAddField}
/>

<EditTagModal
  isOpen={editTagModalOpen}
  onClose={() => setEditTagModalOpen(false)}
  tagId={selectedTagForEdit?.id}
  initialName={selectedTagForEdit?.name}
  initialColor={selectedTagForEdit?.color}
  initialDescription={selectedTagForEdit?.description}
  onSuccess={fetchinvoices}
/>


{customFieldPopup.visible && (
  <div
    ref={popupRef}
    className="fixed z-[9999] bg-white border border-gray-300 rounded-md shadow-md p-3"
    style={{
      top: `${customFieldPopup.y}px`,
      left: `${customFieldPopup.x}px`,
      maxWidth: "300px",
      width: "max-content",
      whiteSpace: "normal",
    }}
    onMouseEnter={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: true }))
    }
    onMouseLeave={() =>
      setCustomFieldPopup((prev) => ({ ...prev, visible: false }))
    }
  >
    <p className="text-gray-800 text-sm font-medium break-words">
      {customFieldPopup.value.length > 80
        ? `${customFieldPopup.value.slice(0, 80)}...`
        : customFieldPopup.value}
    </p>
    {/* <button
      onClick={() =>
        handleViewMore(customFieldPopup.contractKey, customFieldPopup.contractId)
      }
      className="text-[#6F42C1] text-sm font-semibold underline mt-2 hover:text-[#4c2a8a]"
    >
      View More
    </button> */}
  </div>
)}
{showErrorPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 px-4">
    <div className="bg-white rounded-lg shadow-lg pt-4 pb-4 px-4 w-full max-w-[360px] sm:max-w-[400px] text-center relative">
      <img
        src="/alert-icon.svg"
        alt="Alert logo"
        className="mx-auto w-12 h-12"
      />
      <h2 className="text-lg font-semibold text-[#171717] mt-2">
        Can’t Complete Request
      </h2>
      <p className="text-sm text-gray-700 mt-2">{errorMessage}</p>
      <button
        onClick={() => setShowErrorPopup(false)}
        className="mt-4 bg-[#D08BDA] hover:bg-[#c179d2] text-white w-24 h-9 rounded-md font-medium transition"
      >
        Okay
      </button>
    </div>
  </div>
)}

      </div>
    </>
  );
};

export default ContractTable;